<div id="contenedor-ventajas" class="pt-5">
  <div id="contenedor-titulo-ventaja" class="container text-center mb-4 pb-2">
    @if (!sectionVentajaData?.tituloClass) {
    <h1 class="primary-900" [innerHTML]="sectionVentajaData?.titulo"></h1>
    }@else{
    <p class="{{sectionVentajaData?.tituloClass}}" [innerHTML]="sectionVentajaData?.titulo"></p>
    }
    <h2 class="{{sectionVentajaData?.subtituloClass}}" [innerHTML]="sectionVentajaData?.subtitulo"></h2>
  </div>
  <div id="swiper-container-ventajas"
    class="swiper {{sectionVentajaData.refSwiper}} {{swiperVentajas?.pagination?.bullets?.length > 1 ? 'mb-2' : 'mb-4'}}">
    <div class="swiper-wrapper">
      @for (ventaja of ventajasData; track ventaja) {
      <div class="swiper-slide">
        <div class="mb-3 {{ventaja.borderColor}} border-bottom-2 icon-ventaja-width">
          <span class="{{ventaja.iconClass}} material-symbols-outlined">{{ventaja.icono}}</span>
        </div>
        <p class="p1-bold primary-900 mb-2">{{ventaja.titulo}}</p>
        <p class="p2-regular primary-900" [innerHTML]="ventaja.subtitulo"></p>
      </div>
      }
    </div>
    <div id="pagination"
      [ngClass]="{'d-xxl-none' : !isCFFactoring, 'd-none': swiperVentajas?.pagination?.bullets?.length <= 1}"
      class="swiper-pagination position-relative mt-4 {{sectionVentajaData.refSwiper}}-pagination"></div>
  </div>

  @if (sectionVentajaData?.btnTexto) {
  <div class="text-center pb-5" [ngClass]="{'mt-4': swiperVentajas?.pagination?.bullets?.length <= 1}">
    <app-btn-link [linkType]="'routerLink'" [linkUrl]="sectionVentajaData?.btnRuta"
      [linkTitle]="sectionVentajaData?.btnTexto" [linkReturnUrl]="returnUrl"></app-btn-link>
  </div>
  }
</div>